export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderLists@2x.png";